import animatedNature from '../../../../../assests/animated_nature.png';
import squares from '../../../../../assests/blacksquares.jpeg';
import nature from '../../../../../assests/nature.jpeg';

export const squareBg = squares;
export const natureBg = nature;
export const animatedNatureBg = animatedNature;
